import { InjectionToken } from '@angular/core';

import { DiagnosticProfile } from '../models/diagnostic-profile';
import { DIAGNOSTIC_PROFILES } from './diagnostic-profiles.data';

export {
  ALL_EVENT_TYPES,
  DIAGNOSTIC_DEEP_DEBUG_ROLE,
  DIAGNOSTIC_PROFILES,
  validateDiagnosticProfiles,
} from './diagnostic-profiles.data';

export const DIAGNOSTIC_PROFILES_TOKEN = new InjectionToken<
  readonly DiagnosticProfile[]
>('DIAGNOSTIC_PROFILES', {
  providedIn: 'root',
  factory: () => DIAGNOSTIC_PROFILES,
});
